import { useTranslation } from 'react-i18next';
import { SubPartnerAccountStatus, withStyles } from 'vopay';
import StatusSummaryCard from '@/components/Entities/UI/StatusSummaryCard/StatusSummaryCard';
import { PARTNER_TERMINAL_STATUSES } from './partnerOnboardingPipeline';
import styles from './PartnersOverview.module.scss';

const cn = withStyles(styles);

const TERMINAL_STATUSES: ReadonlySet<string> = new Set<string>(PARTNER_TERMINAL_STATUSES);

type PartnerStatusSummaryCardProps = {
  fetching: boolean;
  numTotalPartnerAccounts: number;
  /** Partial while `fetching`; every documented status is present once the summary has responded. */
  statusCounts: { [status: string]: number | undefined };
  /** The tiles, in order — the same list the Status filter offers (see `getPartnerStatusTiles`). */
  stages: readonly SubPartnerAccountStatus[];
  /** A tile filters the partner list below to its status, or clears the filter when it is the selected one. */
  onStatusClick: (status: SubPartnerAccountStatus) => void;
  /** The status the list is filtered to; its tile reads as selected. */
  selectedStatus: SubPartnerAccountStatus | '';
};

export default function PartnerStatusSummaryCard({
  fetching,
  numTotalPartnerAccounts,
  statusCounts,
  stages,
  onStatusClick,
  selectedStatus,
}: PartnerStatusSummaryCardProps) {
  const { t } = useTranslation('translations', { keyPrefix: 'Partners.PartnerManagement.Overview' });

  return (
    <StatusSummaryCard
      fetching={fetching}
      numTotal={numTotalPartnerAccounts}
      totalLabel={t('partnerAccounts', { defaultValue: 'Partner Accounts' })}
      statusCounts={statusCounts}
      terminalStatuses={TERMINAL_STATUSES}
      stages={stages}
      onStatusClick={onStatusClick}
      selectedStatus={selectedStatus}
      groupLabel={t('statusFilterLabel', { defaultValue: 'Filter partner accounts by status' })}
      className={cn('summaryCard')}
      data-testid="partnerStatusSummaryCard"
    />
  );
}
